import React, { Fragment, useState, useEffect } from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    TableRow,
    TableCell,
    TableBody,
    Table,
    TableHead,
    CardMedia,
    CardActions,
    Grid,
    TableContainer,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions, FormControl, InputLabel, Select, MenuItem, Collapse
} from '@mui/material';
import { Item } from './Event';
import IconButton from "@mui/material/IconButton";
import { KeyboardArrowDown, KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { DeleteForever } from "@mui/icons-material";
import { Link } from "react-router-dom";
import ReactQuill from 'react-quill';
import axios from "../../config/axios";
import { useTranslation } from 'react-i18next';
import { useLocalizedContent } from '../../utils/localizedContent';


import 'react-quill/dist/quill.bubble.css';

const roles = ['N/A',
    'Child/Student/Patient',
    'Parent/Caretaker',
    'Healthcare Admin',
    'School Admin',
    'Psychologist (Psy)',
    'Occupational Therapist',
    'Speech and Language Pathologist (SLP)',
    'Developer/Tester',
    'Press/Media', 'Volunteer',
    'Financial Contributor'
];

const EventCard = ({
    id, addressId, userId, file, thumbnail, image, title, body, translations, capacity, participants,
    type, status, items, link, date, timezone, duration, modified, created,
    token, user
}) => {
    const [expandedDescription, setExpandedDescription] = useState(false);
    const [showParticipants, setShowParticipants] = useState(false);
    const [showItems, setShowItems] = useState(false);
    const [firstDialog, setFirstDialog] = useState(false);
    const [secondDialog, setSecondDialog] = useState(false);
    const [alertDialog, setAlertDialog] = useState(false);
    const [alertMessage, setAlertMessage] = useState('Thanks for participating');
    const [deleteParticipantDialog, setDeleteParticipantDialog] = useState(false);
    const [deleteEventDialog, setDeleteEventDialog] = useState(false);
    const [remainingSpots, setRemainingSpots] = useState(capacity);
    const [isEventFull, setIsEventFull] = useState(false);
    const { t } = useTranslation();
    const localizedTitle = useLocalizedContent({ title, translations }, 'title');
    const localizedBody = useLocalizedContent({ body, translations }, 'body');

    // Fetch remaining spots when component mounts
    useEffect(() => {
        const fetchRemainingSpots = async () => {
            try {
                const response = await axios.get(`/event/${id}/spots`);
                setRemainingSpots(response.data.remainingSpots);
                setIsEventFull(response.data.remainingSpots <= 0);
            } catch (error) {
                console.error('Error fetching remaining spots:', error);
                // Fallback to participants array if available
                if (participants) {
                    setRemainingSpots(capacity - participants.length);
                    setIsEventFull(participants.length >= capacity);
                }
            }
        };
        fetchRemainingSpots();
    }, [id, capacity, participants]);
    const [firstname, setFirstname] = useState({ value: '', error: false });
    const [lastname, setLastname] = useState({ value: '', error: false });
    const [email, setEmail] = useState({ value: '', error: false });
    const [role, setRole] = useState({ value: '', error: false });
    const [reason, setReason] = useState({ value: '', error: false });
    const [item, setItem] = useState(items[0]?.name);
    const [quantity, setQuantity] = useState({ value: 0, error: false });
    const [code, setCode] = useState({ value: '', error: false });
    const [validation, setValidation] = useState(false);

    const handleExpandDescription = () => {
        {expandedDescription ? t('read_less') : t('read_more')}
    };
    const handleShowParticipants = () => {
        setShowParticipants(!showParticipants);
    }
    const handleShowItems = () => {
        setShowItems(!showItems);
    }

    function joinEvent() {
        const info = {
            firstname: firstname.value,
            lastname: lastname.value,
            email: email.value,
            role: role.value,
            associations: 'N/A',
            comments: reason.value,
        };

        return axios({
            method: 'post',
            url: `/event/${id}/participant`,
            data: {
                'email': info.email,
                'firstname': info.firstname,
                'lastname': info.lastname,
                'role': info.role,
                'associations': info.associations,
                'comments': info.comments
            },
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async (response) => {
            console.log('Participant Joined = ', response.data);
            setAlertMessage('Thanks for participating! Check your email for a confirmation code.');
            // Refresh remaining spots after successful join
            try {
                const spotsResponse = await axios.get(`/event/${id}/spots`);
                setRemainingSpots(spotsResponse.data.remainingSpots);
                setIsEventFull(spotsResponse.data.remainingSpots <= 0);
            } catch (err) {
                // Decrement locally if API fails
                setRemainingSpots(prev => Math.max(0, prev - 1));
            }
            return { success: true };
        }).catch(error => {
            console.error(error);
            const errorMessage = error.response?.data?.message || 'Failed to join event';
            if (errorMessage.includes('maximum capacity')) {
                setIsEventFull(true);
                setAlertMessage('Sorry, this event has reached maximum capacity.');
            } else if (errorMessage.includes('already registered')) {
                setAlertMessage('You are already registered for this event.');
            } else {
                setAlertMessage(errorMessage);
            }
            return { success: false, message: errorMessage };
        });
    }

    const handleFirstDialogOpen = () => {
        setFirstDialog(true);
    }
    const handleFirstDialogClose = async () => {
        const result = await joinEvent();
        setFirstDialog(false);
        if (result?.success && items && items.length > 0) {
            setSecondDialog(true);
        } else {
            setAlertDialog(true);
        }
    }
    const handleSecondDialogClose = () => {
        setSecondDialog(false);
        setFirstDialog(true);
    }
    const handleSkipItem = () => {
        setSecondDialog(false);
        setAlertDialog(true);
    }
    const handleDialogClose = () => {
        setFirstDialog(false);
        setSecondDialog(false);
        setAlertDialog(false);
        setDeleteParticipantDialog(false);
        setDeleteEventDialog(false);
    }

    function bringItemToEvent() {
        const info = {
            email: email.value,
            item: item,
            quantity: quantity.value,
            code: code.value
        };

        let eventItemId;
        for (let i = 0; i < items.length; i++) {
            if (item === items[i].name) {
                eventItemId = items[i].id;
            }
        }

        axios({
            method: 'post',
            url: `/event/${id}/participant/${info.email}/item/${eventItemId}`,
            data: {
                'quantity': info.quantity
            },
            headers: {
                'code': info.code,
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            console.log('Participant Added Item = ', response.data);
        }).catch(error => {
            console.error(error);
        });

        setSecondDialog(false);
        setAlertDialog(true);
    }

    function deleteEvent() {
        axios({
            method: 'delete',
            url: `/user/event/${id}`,
            headers: {
                'token': token
            }
        }).then((response) => {
            console.log('Event deleted = ', response.data);
        }).catch(error => {
            console.error(error);
        });

        setDeleteEventDialog(false);
    }

    function deleteParticipant(eventId, email) {
        axios({
            method: 'delete',
            url: `/event/${eventId}/participant/${email}`,
            headers: {
                'Content-Type': 'application/json',
                'token': token
            }
        }).then((response) => {
            console.log('Participant Deleted = ', response.data);
        }).catch(error => {
            console.error(error);
        });

        setDeleteParticipantDialog(false);
    }

    function displayParticipants(participants) {
        return (
            <>
                <Button color={'primary'} className={'purpleButton'}
                    onClick={handleShowParticipants}>
                            {t('EventsPage.HideParticipants')}
                </Button>

                <TableContainer component={Paper}>
                    <Table aria-label="participants table" size={'small'}>
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell>{t('EventsPage.NewsEvents.Firstname')}</TableCell>
                                <TableCell>{t('EventsPage.NewsEvents.Lastname')}</TableCell>
                                <TableCell>{t('EventsPage.NewsEvents.Role')}</TableCell>
                                {(user?.id === userId || user?.authRole === 'admin') &&
                                    <>
                                        <TableCell>{t('EventsPage.NewsEvents.Email')}</TableCell>
                                        {status !== 'past'
                                            ? <TableCell>{t('EventsPage.NewsEvents.Actions')}</TableCell>
                                            : <></>
                                        }
                                    </>
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {participants.map((participant, index) => (
                                <ParticipantRow key={participant.id} participant={participant} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        )
    }

    function ParticipantRow({ participant }) {
        const [expandedParticipant, setExpandedParticipant] = useState(false);
        const handleExpandRow = () => {
            setExpandedParticipant(!expandedParticipant);
        }
        return (
            <Fragment>
                <TableRow sx={{ '& > *': { borderBottom: 'unset' }, '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell>
                        <IconButton aria-label={'expand more'} onClick={handleExpandRow}
                            sx={{ width: '10px', height: '10px' }}>
                            {expandedParticipant ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                        </IconButton>
                    </TableCell>
                    <TableCell>{participant.firstname}</TableCell>
                    <TableCell>{participant.lastname}</TableCell>
                    <TableCell>{participant.role}</TableCell>
                    {(user?.id === userId || user?.authRole === 'admin') &&
                        <>
                            <TableCell>{participant.email}</TableCell>
                            {status !== 'past' &&
                                <TableCell>
                                    <Button onClick={() => setDeleteParticipantDialog(true)}>Delete</Button>
                                </TableCell>
                            }
                        </>
                    }
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={expandedParticipant} timeout={'auto'}>
                            {(Array.isArray(participant.items) && participant.items.length > 0) &&
                                <Box>
                                    <Typography variant={'h6'}>
                                        Items
                                    </Typography>
                                    <Table size={'small'} aria-label={'items'}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Name</TableCell>
                                                <TableCell>Quantity</TableCell>
                                                <TableCell>Measurement</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {participant.items.map((item) => (
                                                <TableRow key={item.id}>
                                                    <TableCell>{item.name}</TableCell>
                                                    <TableCell>{item.quantity}</TableCell>
                                                    <TableCell>{item.measurement}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            }
                            <Box>
                                <Typography variant={'h6'} sx={{ display: 'inline' }}>
                                    {'Reason for entry: '}
                                </Typography>
                                <Typography sx={{ display: 'inline' }}>
                                    {participant.comments}
                                </Typography>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>

                <Dialog open={deleteParticipantDialog} onClose={handleDialogClose}>
                    <DialogContent>
                        <Box>
                            Do you want to delete this participant/remove yourself?
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => deleteParticipant(id, participant.email)} color="primary">
                            Yes
                        </Button>
                        <Button onClick={handleDialogClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }

    function displayItems(items) {
        let newTotalItems = [];
        for (let i = 0; i < items.length; i++) {
            newTotalItems[i] = new Item(items[i].id, items[i].eventId, items[i].name, items[i].quantity, items[i].measurement, items[i].created, items[i].modified);
        }
        for (let i = 0; i < newTotalItems.length; i++) {
            for (let j = 0; j < participants.length; j++) {
                const participantItems = participants[j].items;
                for (let k = 0; k < participantItems.length; k++) {
                    if (newTotalItems[i].id === participantItems[k].id) {
                        newTotalItems[i].setQuantity(newTotalItems[i].quantity - participantItems[k].quantity);
                    }
                }
            }
        }

        return (
            <>
                <Button color={'primary'} className={'purpleButton'}
                    onClick={handleShowItems}>
                    Hide Items
                </Button>

                <TableContainer component={Paper}>
                    <Table aria-label="items table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>Measurement</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {newTotalItems.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>{item.quantity}</TableCell>
                                    <TableCell>{item.measurement}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        )
    }

    const linebreakRegex = /<p>(.*?)<\/p>/g;
    const linebreaks = (localizedBody?.match(linebreakRegex) || []).length;

    return (
        <div className="m-3">
            <Card sx={{ display: 'flex' }}>
                <Grid container direction={'column'}>
                    <Grid item container direction={'row'}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', maxWidth: '70%', width: '70%' }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {localizedTitle}
                                    </Typography>
                                    {(user?.id === userId || user?.authRole === 'admin') &&
                                        <IconButton onClick={() => setDeleteEventDialog(true)}>
                                            <DeleteForever sx={{ color: 'red' }} />
                                        </IconButton>
                                    }
                                </Box>

                                <Typography variant="body2" color="text.secondary">
                                    {date.start + ' - ' + date.end} ; &nbsp;
                                    {duration.days && (duration.days + 'day(s), ')}
                                    {duration.hours && (duration.hours + 'hour(s), ')}
                                    {duration.minutes && (duration.minutes + 'minute(s)')}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {t('EventsPage.EventType')} {type}
                                </Typography>
                                {link && (
                                    <Typography variant="body2" color="text.secondary">
                                        {t('EventsPage.NewsEvents.MeetingLink')} {link}
                                    </Typography>
                                )}
                                <Grid container direction={'row'}>
                                    {(capacity != null) &&
                                        <Typography variant="body2" color="text.secondary">
                                            {t('EventsPage.NewsEvents.Capacity')}: {capacity}
                                        </Typography>
                                    }
                                    {remainingSpots > 0
                                        ? <Typography variant="body2" color="text.secondary">
                                            &nbsp;{'; ' + t('EventsPage.NewsEvents.SpotsOpen') + ': ' + remainingSpots}
                                        </Typography>
                                        : <Typography variant="body2" color="error">
                                            &nbsp;; {t('EventsPage.NewsEvents.FullyBooked')}
                                        </Typography>
                                    }
                                </Grid>

                                {token &&
                                    <>
                                        {(Array.isArray(participants) && participants.length > 0) &&
                                            <>
                                                {showParticipants
                                                    ? <>
                                                        {displayParticipants(participants)}
                                                    </>
                                                    : <Button color={'primary'} className={'purpleButton'}
                                                        onClick={handleShowParticipants}>
                                                        {t('EventsPage.ShowParticipants')}
                                                    </Button>
                                                }
                                            </>
                                        }
                                    </>
                                }

                                {(Array.isArray(items) && items.length > 0) &&
                                    <>
                                        {showItems
                                            ? <>
                                                {displayItems(items)}
                                            </>
                                            : <Button color={'primary'} className={'purpleButton'}
                                                onClick={handleShowItems}>
                                                {t('EventsPage.ShowItems')}
                                            </Button>
                                        }
                                    </>
                                }

                                {(body) &&
                                    <>
                                        <Box sx={{
                                            overflow: 'hidden',
                                            height: expandedDescription ? 'none' : '4.4em'
                                        }}>
                                            <ReactQuill
                                                value={localizedBody}
                                                readOnly={true}
                                                theme={'bubble'}
                                            />
                                        </Box>
                                        {(localizedBody.length > 100 || linebreaks > 3) && (
                                            <Button onClick={handleExpandDescription}>
                                                {expandedDescription ? 'Read Less' : 'Read More'}
                                            </Button>
                                        )}
                                    </>}
                                {(file) &&
                                    <a href={file} target={'_blank'} rel={'noopener noreferrer'}>Download File</a>
                                }
                            </CardContent>
                        </Box>
                        <Box
                            sx={{
                                width: '30%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: 'rgba(0, 0, 0, 0.05)',
                            }}
                        >
                            <CardMedia
                                style={{ maxHeight: '100%', maxWidth: '100%', padding: '16px' }}
                                component={'img'}
                                src={thumbnail ? thumbnail : '/vividKidsLogo.svg'}
                                title={'Event thumbnail'} />
                        </Box>
                    </Grid>
                    {status !== 'past' &&
                        <>
                            {capacity > 0 &&
                                <>
                                    {token
                                        ? <Grid item>
                                            <CardActions>
                                                {isEventFull || (participants && participants.length >= capacity)
                                                    ? <Button variant='contained' disabled sx={{ m: 2 }}>
                                                        {t('EventsPage.EventFull')}
                                                    </Button>
                                                    : <Button onClick={handleFirstDialogOpen} variant='contained'
                                                        sx={{ m: 2 }}>{t('EventsPage.Join')}</Button>
                                                }
                                            </CardActions>
                                        </Grid>
                                        : <Grid item>
                                            <CardActions>
                                                {isEventFull || (participants && participants.length >= capacity)
                                                    ? <Button variant='contained' disabled sx={{ m: 2 }}>
                                                        {t('EventsPage.EventFull')}
                                                    </Button>
                                                    : <Button sx={{ m: 2 }}>
                                                        <Link to={'/login'}>
                                                            {t('EventsPage.Sign up to participate')}
                                                        </Link>
                                                    </Button>
                                                }
                                            </CardActions>
                                        </Grid>
                                    }
                                </>
                            }
                        </>
                    }
                </Grid>
            </Card>

            <Dialog open={firstDialog} onClose={handleDialogClose} fullWidth={true} maxWidth={'md'}>
                <DialogTitle>{t('EventsPage.NewsEvents.JoinEvent')}</DialogTitle>
                <DialogContent>
                    <Box component={'form'}
                        sx={{ width: 'fit-content', display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            columnGap: 2,
                            padding: '1rem 0'
                        }}>
                            <TextField
                                label={'Firstname'}
                                value={firstname.value}
                                onChange={(e) => setFirstname({ ...firstname, value: e.target.value })}
                                required={true}
                                error={firstname.error}
                            />
                            <TextField
                                label={'Lastname'}
                                value={lastname.value}
                                onChange={(e) => setLastname({ ...lastname, value: e.target.value })}
                                required={true}
                            />
                            <TextField
                                label={'Email'}
                                type={'email'}
                                value={email.value}
                                onChange={(e) => setEmail({ ...email, value: e.target.value })}
                                required={true}
                            />
                        </Box>
                        <FormControl>
                            <InputLabel>Role</InputLabel>
                            <Select value={role.value} label={'Role'} autoWidth={true}
                                onChange={(e) => setRole({ ...role, value: e.target.value })}>
                                {roles?.map(role => (
                                    <MenuItem key={role} value={`${role}`}>
                                        {role}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box>
                            <label>Reason for entry</label>
                            <textarea
                                aria-label={'Reason for entry'}
                                value={reason.value}
                                onChange={(e) => setReason({ ...reason, value: e.target.value })}
                                required={true} rows={3} cols={100}
                                style={{ width: 'max-content' }}
                            />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent={'space-between'}>
                        <Grid item>
                            <Button onClick={handleDialogClose} color="primary">
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button onClick={handleFirstDialogClose} color="primary">
                                Continue
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            <Dialog open={secondDialog} onClose={handleDialogClose} fullWidth={true} maxWidth={'md'}>
                <DialogTitle>
                    <Box>
                        <IconButton aria-label={'back button'} onClick={handleSecondDialogClose}>
                            <KeyboardArrowLeft />
                        </IconButton>
                        Bring Item
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Box component={'form'}
                        sx={{ width: 'fit-content', display: 'flex', flexDirection: 'column' }}>
                        <Box>
                            <Typography>
                                Item Code is required to bring an item. Click the button below to send a code to
                                your email inserted previously. You can skip this process.
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <TextField
                                    label={'Item Code'}
                                    type={'number'}
                                    value={code.value}
                                    onChange={(e) => setCode({ ...code, value: e.target.value })}
                                    required={item !== 'none'}
                                />
                                <Button>
                                    Send Code
                                </Button>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '1rem 0' }}>
                            <FormControl>
                                <InputLabel>Item</InputLabel>
                                <Select value={item} label={'Item'} autoWidth={true}
                                    onChange={(e) => setItem(e.target.value)}>
                                    {items?.map(item => (
                                        <MenuItem key={item.id} value={`${item.name}`}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField
                                label={'Quantity'}
                                type={'number'}
                                value={quantity.value}
                                onChange={(e) => setQuantity({ ...quantity, value: e.target.value })}
                                required={true}
                            />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent={'space-between'}>
                        <Grid item>
                            <Button onClick={handleDialogClose} color="primary">
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button onClick={handleSkipItem} color="primary">
                                Skip
                            </Button>
                            <Button onClick={bringItemToEvent} color="primary">
                                Finish
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            <Dialog open={alertDialog} onClose={handleDialogClose}>
                <DialogContent>
                    <Box>
                        {alertMessage}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteEventDialog} onClose={handleDialogClose}>
                <DialogContent>
                    <Box>
                        {t('EventsPage.NewsEvents.DeleteEvent')}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={deleteEvent} color="primary">
                        {t('EventsPage.Yes')}
                    </Button>
                    <Button onClick={handleDialogClose} color="primary">
                        {t('EventsPage.No')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default EventCard;
